var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import { Card, CardBody, Tooltip } from 'reactstrap';
import theme from '../Theme';
var CuadroCard = /** @class */ (function (_super) {
    __extends(CuadroCard, _super);
    function CuadroCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            tooltip: false
        };
        _this.handleToggleTooltip = function () {
            _this.setState(function (prev) { return ({ tooltip: !prev.tooltip }); });
        };
        return _this;
    }
    CuadroCard.prototype.render = function () {
        var _a = this.props, title = _a.title, content = _a.content, value = _a.value, type = _a.type, id = _a.id, tooltipContent = _a.tooltipContent, propsTooltip = _a.propsTooltip;
        var styleCard = this.props.styleCard || styleCuadroCard;
        var titleStyle = this.props.titleStyle || styleTittle;
        return (React.createElement("div", { id: this.props.id, className: "col-sm-6 col-md-4 col-lg-3 col-xl-2" },
            React.createElement(Card, { style: styleCard },
                React.createElement(CardBody, { className: "pb-0" },
                    React.createElement("div", null, content)),
                React.createElement(CardBody, { className: "pb-0 pt-0" },
                    React.createElement("div", { className: "text-value" }, value))),
            id && React.createElement(Tooltip, __assign({ target: id, boundariesElement: "window", isOpen: this.state.tooltip, placement: "top", toggle: this.handleToggleTooltip }, propsTooltip), tooltipContent)));
    };
    return CuadroCard;
}(Component));
export default CuadroCard;
var styleTittle = { color: theme.color.primary };
var styleCuadroCard = {
    background: 'white', height: '150px', color: theme.color.secondary, borderColor: theme.color.primary
};



//////////////////
// WEBPACK FOOTER
// ./src/components/CuadroCard.tsx
// module id = 506
// module chunks = 0